// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__3YOwv","pane":"styles_pane__yL3tE","hint":"styles_hint__7oYCx"};